export const getNumberPositivityStatus = (value: number): 'positive' | 'negative' | 'zero' => {
  if (value > 0) {
    return 'positive';
  }

  if (value < 0) {
    return 'negative';
  }

  return 'zero';
};

export const formatNumber = (num: number) => {
  if (typeof num !== 'number' && typeof num !== 'string') {
    throw new TypeError('Input must be a number or a numeric string');
  }

  const fixedNum = Number(num).toFixed(2);
  return fixedNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
